
import {
  Button,
  Dialog,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  DatePicker,
} from 'element-ui';

export default {
  data() {
    return {
      visible: false,
      form: {
        firstName: '',
        lastName: '',
        mobilePhone: '',
        to: '',
        dateOption: 'today',
        customDate: '',
        message: '',
      },
    };
  },
  computed: {
    formattedDate() {
      if (this.form.dateOption === 'today') {
        return this.formatDate(new Date());
      }
      if (this.form.customDate) {
        return this.formatDate(this.form.customDate);
      }
      return '-';
    },
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return '-';
      }
      const resolvedDate = typeof date === 'string' ? new Date(date) : date;
      if (Number.isNaN(resolvedDate.getTime())) {
        return '-';
      }
      const locale = this.$i18n?.locale
        ? this.$i18n.locale.replace('_', '-')
        : undefined;
      return resolvedDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
  components: {
    Button,
    Dialog,
    Form,
    FormItem,
    Input,
    Radio,
    RadioGroup,
    DatePicker,
  },
};
